import { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Divider, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';

export interface MetadataRowProps {
  label: string;
  value: string;
}

export const MetadataRow: React.FC<MetadataRowProps> = ({ label, value }) => {
  const { tokens } = useTheme<LensTheme>();
  return (
    <>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          py: tokens.core.spacing[2].value,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: tokens.semantic.fontWeight.emphasis.value,
            flexBasis: '40%',
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ flexBasis: '58%', textAlign: 'left' }}
        >
          {value}
        </Typography>
      </Stack>
      <Divider />
    </>
  );
};
